module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAxMDI0IDEwMjQiIHZlcnNpb249IjEuMSI+PHBhdGggZD0iTTU3NiA4MzJhNjQgNjQgMCAxIDEtMTI4IDAgNjQgNjQgMCAwIDEgMTI4IDB6IG0wLTMyMGE2NCA2NCAwIDEgMS0xMjggMCA2NCA2NCAwIDAgMSAxMjggMHogbTAtMzIwYTY0IDY0IDAgMSAxLTEyOCAwIDY0IDY0IDAgMCAxIDEyOCAweiIgZmlsbD0iIzAiIHAtaWQ9IjU5OCI+PC9wYXRoPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/Overflow menu vertical-outlined.svg
// module id = HBI3
// module chunks = 74